interface PrintFooterProps {
	reflectionTitle: string;
	createdDate: string;
}

export function PrintFooter({
	reflectionTitle,
	createdDate,
}: PrintFooterProps) {
	const formatDate = (dateString: string) => {
		return new Date(dateString).toLocaleDateString("en-US", {
			year: "numeric",
			month: "long",
			day: "numeric",
		});
	};

	return (
		<div className="hidden print-footer">
			<p>
				{reflectionTitle} | Created: {formatDate(createdDate)} | Reflection
				Journal
			</p>
		</div>
	);
}
